const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the user categories directive to manage editing categories on user objects
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Users} Users the resource defined to manage Users
 */
app.directive('managerUserCategories', ['Application', 'AccessHelper', 'Categories', function(Application, AccessHelper, Categories) {
    return {
      restrict: 'E',
      scope: {
        userId: '=',
        user: '=',
        managerConfiguration: '=',
        manager: '@?',
        onClose: '&?'
      },
      replace: true,
      template: require('../../../templates/directives/manager/manager-user-categories.html'),
      controller: ['$scope', function($scope) {
        var self = this;
        self.creator = Application.access.user;
        self.categoriesRecieved = false;
        self.flags = Application.features.flags();


        var types = ['departments', 'locations', 'teams', 'org_levels', 'grades'];
          var userToType = {
            linked_departments: 'departments',
            linked_locations: 'locations',
            linked_teams: 'teams',
            linked_org_level: 'org_levels',
            linked_grade: 'grades',
            groups: 'groups'
          };

          const restrictedGroup = Application.access.profile && Application.access.profile.permissions && Application.access.profile.permissions.admin && Application.access.profile.permissions.admin.users && Application.access.profile.permissions.admin.users.user_group || {};
          self.restricted = AccessHelper.isAllowed(['admin', 'users', 'restricted_access'], null, ['admin', 'creator', 'manager']);
          self.restrictions = {};
          self.allCategories = {};
          self.useRestricted = {};
          self.managerRestricted = {};
          self.hideOptions = {};
          self.restrictedValues = {};
          types.forEach(function(type) {
            self.useRestricted[type] = false;
            self.managerRestricted[type] = false;
            self.hideOptions[type] = false;
            self.restrictions[type] = !!self.restricted;
            self.allCategories[type] = [];
            if (!restrictedGroup[type] || !restrictedGroup[type].length) {
              self.restrictions[type] = false;
            }
          });

          self.topLocations = [];
          self.topDepartments = [];
          self.directory = {};
          self.locationOptions = {};
          self.locationSelections = {};
          self.departmentOptions = {};
          self.departmentSelections = {};
          self.originalTeams = [];
          self.originalGrades = [];
          self.originalOrgLevels = [];
          self.originalTeams = [];
          self.originalGrades = [];
          self.originalOrgLevels = [];
          self.orgLevelSelection;
          self.gradeSelection;
          self.newTeamSelection;
          self.teamsSelections = [];
          self.orgLevelSelection = null;
          self.gradeSelection = null;


           self.init = function () {
              Categories.find({
                fields: 'name,level,children,parent,location,department,team,org_level,category,grade',
                category: '$ne,true'
              }).$promise.then(function(items) {
                angular.forEach(items, function(cat) {
                  cat.value = cat._id;
                  if (cat.location) {
                    if (cat.level === 1) {
                      self.topLocations.push(cat);
                    }
                    self.allCategories.locations.push(cat);
                  }
                  if (cat.department) {
                    if (cat.level === 1) {
                      self.topDepartments.push(cat);
                    }
                    self.allCategories.departments.push(cat);
                  }
                  if (cat.team) {
                    self.originalTeams.push(cat);
                    self.allCategories.teams.push(cat);
                  }
                  if (cat.org_level) {
                    self.originalOrgLevels.push(cat);
                    self.allCategories.org_levels.push(cat);
                  }
                  if (cat.grade) {
                    self.originalGrades.push(cat);
                    self.allCategories.grades.push(cat);
                  }
                  self.directory[cat._id] = cat;
                });
                self.setTeams();
                self.setOrgLevel($scope.user.linked_org_level);
                self.setGrade($scope.user.linked_grade);
                self.setDepartment($scope.user.linked_departments[0]);
                self.setLocation($scope.user.linked_locations[0]);
                
                types.forEach(function(type) {
                  if (self.restricted && self.restrictions[type] && self.allCategories[type] && self.allCategories[type].length) {
                    self.useRestricted[type] = true;
                  }
                });
                if ($scope.manager && $scope.managerConfiguration) {
                  if ($scope.managerConfiguration.segmentation_subset && $scope.managerConfiguration.segmentation_subset.length) {
                    $scope.managerConfiguration.segmentation_subset.forEach(function(item) {
                      if (userToType[item]) {
                        self.useRestricted[userToType[item]] = true;
                        self.managerRestricted[userToType[item]] = true;
                        self.restrictedValues[userToType[item]] = getRestrictedValues(item);
                        if (!self.creator[item] || (self.creator[item] && self.creator[item].length === 0)) {
                          self.hideOptions[userToType[item]] = true;
                        }
                      }
                    });
                  }
                  if ($scope.managerConfiguration.hide_options && $scope.managerConfiguration.hide_options.length) {
                    $scope.managerConfiguration.hide_options.forEach(function(item) {
                      if (userToType[item]) {
                        self.hideOptions[userToType[item]] = true;
                      }
                    });
                  }
                }

              self.categoriesRecieved = true;
             }
             ).catch(err => {
              console.log(err);
            });
          };
         
         const getRestrictedValues = function(type) {
           // groups are handled separately
           if (type === "groups") {
             return;
           }
           if (!$scope.user[type]) {
             return;
           }
          // Look up type values on user
          let typeValues = [];
          if (Array.isArray($scope.user[type])) {
            typeValues = $scope.user[type];
          } else {
            typeValues.push($scope.user[type]);
          }

          if (!typeValues.length) {
            return;
          }
          // Compare to available manager values (ignore groups)
          const restrictedTypeValues = typeValues.filter(value => {
            return self.creator[type] && !self.creator[type].includes(value);
          });
          // return object with data for su select components 
          return restrictedTypeValues.map(restrictedValue => {
            return {
              value: restrictedValue, 
              name: self.directory[restrictedValue].name
            };
          });
         };

          var setChildOptions = function(id, type, options) {
            options.grandChildren = [];
            if (type === 'children') {
              options.children = [];
            }
            var items = [];
            if (self.directory[id] && self.directory[id].children) {
              items = mapToChildOptions(id);
              options[type] = items;
            }
          };

          const mapToChildOptions = id => {
            if (self.directory[id].children.length) {
              return self.directory[id].children.map(childId => {
                return self.directory[childId];
              });
            }
          };

          const checkChildOptionsAndSelections = function(id, selections, options) {
            if (self.directory[id].parent) {
              const parentId = self.directory[id].parent;
              if (self.directory[parentId].parent) {
                const grandparentId = self.directory[parentId].parent;
                options.children = mapToChildOptions(grandparentId);
                options.grandChildren = mapToChildOptions(parentId);
                selections.top = grandparentId;
                selections.child = parentId;
                selections.grandChild = id;
                return;
              }
              options.children = mapToChildOptions(parentId);
              selections.top = parentId;
              selections.child = id;
              if (self.directory[id].children && self.directory[id].children.length) {
                options.grandChildren = mapToChildOptions(id);
              }
              return;
            } 
            if (self.directory[id].children && self.directory[id].children.length) {
              options.children = mapToChildOptions(id);
            }
            selections.top = id;
            return;
          };
          

          self.setOrgLevel = function(id) {
            if (id && self.directory[id]) {
              $scope.user.linked_org_level = id;
              self.orgLevelSelection = id;
              return;
            }
          };

          self.setGrade = function(id) {
            if (id && self.directory[id]) {
              $scope.user.linked_grade = id;
              self.gradeSelection = id;
              return;
            }
          };

          self.setLocation = function(id) {
            if (id && self.directory[id]) {
              $scope.user.linked_locations = [id];
              checkChildOptionsAndSelections(id, self.locationSelections, self.locationOptions);
              return;
            }
          };

          self.setDepartment = function(id) {
            if (id && self.directory[id]) {
              $scope.user.linked_departments = [id];
              checkChildOptionsAndSelections(id, self.departmentSelections, self.departmentOptions);
            }
          };

          self.setTeams = function() {
            
            self.teamsSelections = [];
            const segmentation = $scope.manager && $scope.managerConfiguration?.segmentation_subset || [];
            if (!$scope.user.linked_teams || !$scope.user.linked_teams.length) {
              return;
            }
            $scope.user.linked_teams.forEach(function(teamId) {
              if (teamId && self.directory[teamId]) {
                // Check if manager is allowed see this team
                if (segmentation.length && segmentation.includes('linked_teams') && !self.creator.linked_teams.includes(teamId)) {
                  return;
                }
                self.teamsSelections.push(teamId);
              }
            });
          };

          self.removeTeam = function(id) {
            var index = $scope.user.linked_teams.indexOf(id);
            if (!index && index !== 0) {
              return;
            }
            $scope.user.linked_teams.splice(index, 1);
            self.setTeams();
          };

          $scope.$watch('editCats.orgLevelSelection', function(newVal, oldVal) {
            if (newVal && self.directory[newVal]) {
              if ($scope.user.linked_org_level === newVal) {
                return;
              }
              self.setOrgLevel(newVal);
            }
          }, true);

          $scope.$watch('editCats.gradeSelection', function(newVal, oldVal) {
            if (newVal && self.directory[newVal]) {
              if ($scope.user.linked_grade === newVal) {
                return;
              }
              self.setGrade(newVal);
            }
          }, true);

          $scope.$watch('editCats.newTeamSelection', function(newVal, oldVal) {
            if (newVal && newVal !== oldVal) {
              if ($scope.user.linked_teams.indexOf(newVal) !== -1) {
                self.newTeamSelection = null;
                return;
              }
              $scope.user.linked_teams.push(newVal);
              self.newTeamSelection = null;
              self.setTeams();
            }
          }, true);

          $scope.$watch('editCats.locationSelections', function(newVal, oldVal) {
            if (!self.categoriesRecieved) {
              return;
            }
            if (newVal.grandChild && newVal.grandChild !== oldVal.grandChild) {
              $scope.user.linked_locations = [newVal.grandChild];
              return;
            }
            if (newVal.child && newVal.child !== oldVal.child) {
              $scope.user.linked_locations = [newVal.child];
              setChildOptions(newVal.child, 'grandChildren', self.locationOptions);
              self.locationSelections.grandChild = null;
              return;
            }
            if (newVal.top && newVal.top !== oldVal.top) {
              $scope.user.linked_locations = [newVal.top];
              setChildOptions(newVal.top, 'children', self.locationOptions);
              self.locationSelections.grandChild = null;
              self.locationSelections.child = null;
              return;
            }
          }, true);

          $scope.$watch('editCats.departmentSelections', function(newVal, oldVal) {
            if (!self.categoriesRecieved) {
              return;
            }
            if (newVal.grandChild && newVal.grandChild !== oldVal.grandChild) {
              $scope.user.linked_departments = [newVal.grandChild];
              return;
            }
            if (newVal.child && newVal.child !== oldVal.child) {
              $scope.user.linked_departments = [newVal.child];
              setChildOptions(newVal.child, 'grandChildren', self.departmentOptions);
              self.departmentSelections.grandChild = null;
              return;
            }
            if (newVal.top && newVal.top !== oldVal.top) {
              $scope.user.linked_departments = [newVal.top];
              setChildOptions(newVal.top, 'children', self.departmentOptions);
              self.departmentSelections.grandChild = null;
              self.departmentSelections.child = null;
              return;
            }
          }, true);

          self.init();

      }],
      controllerAs: 'editCats'
    }}]);